import { ColorNeutralWhite, Spacing16, Spacing24, Spacing32, Spacing56, Spacing64 } from 'autogen/design-tokens/tokens';
import { Typography } from 'components/generic/typography';
import React from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import Layout from 'components/Layout';
import type { InventoryLaneProps } from './shared/types';
import { InventoryLaneList, getNumberOfItems } from './index';

const StyledSection = styled(Layout.Section)<{ noOfItemsMobile: number; noOfItemsDesktop: number }>`
    display: ${({ noOfItemsMobile }) => (noOfItemsMobile === 0 ? 'none' : 'grid')};
    background: ${ColorNeutralWhite};

    ${breakpoint.up(sizes.sm)} {
        display: ${({ noOfItemsDesktop }) => (noOfItemsDesktop === 0 ? 'none' : 'grid')};
    }
`;

const StyledBody = styled(Typography.Body)`
    text-transform: uppercase;
    letter-spacing: 0.06em;
    text-align: center;
`;

export default function InventoryLaneConnectedContent({ model }: { model: InventoryLaneProps }) {
    const { noOfItemsMobile, noOfItemsDesktop } = getNumberOfItems(model);

    if (!model.inventoryLaneBlocks?.length) return null;

    return (
        <StyledSection
            heading={model.inventoryLaneHeader}
            headingRenderer={(heading) =>
                heading ? (
                    <StyledBody as="span" size="M" strong>
                        {heading}
                    </StyledBody>
                ) : null
            }
            noOfItemsDesktop={noOfItemsDesktop}
            noOfItemsMobile={noOfItemsMobile}
        >
            <InventoryLaneList content={model} />
        </StyledSection>
    );
}
